<template>
    <div id="MyBag">
        <div class="bag_header">
            <div class="bag_header_l">
                <p>全选</p>
                <van-switch v-model="select_All" size="20px" active-color="#2ae1bc" inactive-color="#1e213b"
                    @input="OnSelectAll" />
                <div class="all_price">
                    已选
                    <span style="color: #2ae1bc;">{{ selectCount }}</span>
                </div>
                <div class="all_price">
                    总价值
                    <img src="@/assets/images/PublicImg/JinBi.png" alt="">
                    <span>{{ selectBean }}</span>
                </div>
            </div>
            <div class="bag_header_c">
                您的饰品
            </div>
            <div class="bag_header_r">
                <div class="btn_wrap" @click="WholeCash">
                    全部分解
                    <img src="@/assets/images/setting/btn_icon_quanbufenjie.png" alt="">
                </div>
                <div class="btn_wrap">
                    取消提取
                    <img src="@/assets/images/setting/btn_icon_quxiaotiqu.png" alt="">
                </div>
                <div class="btn_wrap" @click="WholeExtract">
                    提取
                    <img src="@/assets/images/setting/btn_icon_tiqu.png" alt="">
                </div>
            </div>
        </div>
        <van-loading class="loading" v-show="loadingShow == true" color="#ffffff" size="60" />
        <div class="goods_list_wrap">
            <template v-if="itemLists.length != 0">
                <div class="goods_list" v-show="loadingShow == false">
                    <div class="goods_item" v-for="(item, index) in itemLists" :key="index" :class="{ 'active': item.Select == true }">
                        <div class="goods_item_background" :class="item.lv | LvGuoLv"> 
                        </div>
                        <div class="goods_img">
                            <img :src=item.cover alt="">
                        </div>

                        <div class="choose" @click="SelectGoods(item, index)">
                        </div>

                        <div class="item_info">
                            <div class="price">
                                <img class="price_coin" src="@/assets/images/PublicImg/JinBi.png" alt="">
                                {{ item.bean }}
                            </div>
                            {{ item.name }}
                        </div>

                    </div>
                </div>
            </template>
            <template v-else>
                <div class="empty_data" v-show="loadingShow == false">
                    <p>暂无数据</p>
                </div>
            </template>
        </div>
        <div class="PageNum">
            <el-pagination background layout="prev, pager, next" @current-change="HandleCurrentChange"
				:page-size="per_page" :total="item_total_num">
			</el-pagination>
		</div>
    </div>
</template>

<script>
import {
    mapMutations
} from 'vuex'
import {
    Storage,
    PersonalInfo,
    Cash,
    Extract,
} from '@/network/api.js'
export default {
    name: 'MyBag',
    data() {
        return {
            loadingShow: true,  ///饰品加载中

            itemLists: [],      ///背包饰品列表
            item_total_num: 0,  ///背包饰品总数
            per_page: 10,       ///一页多少个饰品
            cur_page: 1,    ///当前查看的页数


            select_All: false,  ///全部选中
            selectBean: 0.00,  ///选中饰品的价格
            selectCount: 0,
        }
    },
    created() {
        this.GetStorage(1);
    },
    activated() {
        this.GetStorage(1);
    },
    filters: {
		LvGuoLv(val) {
			if (val == '1') {
				return 'lv1'
			} else if (val == '2') {
				return 'lv2'
			} else if (val == '3') {
				return 'lv3'
			} else if (val == '4') {
				return 'lv4'
			} else if (val == '5') {
				return 'lv5'
			}
		},
	},
    methods: {
        OnSelectAll(checked) {
            if (checked == false) {
                for (let i = 0; i < this.itemLists.length; i++) {
                    delete this.itemLists[i].Select;
                }
            }
            else {
                for (let i = 0; i < this.itemLists.length; i++) {
                    this.itemLists[i]['Select'] = true;
                }
            }

            ///计算数量
            this.SelectBean();

        },

        SelectBean() {
            this.selectBean = 0.00;
            this.selectCount = 0;
            for (let i = 0; i < this.itemLists.length; i++) {
                if (this.itemLists[i].Select == true) {
                    this.selectBean += Number(this.itemLists[i].bean);
                    this.selectCount++;
                }
            }

            this.selectBean = this.selectBean.toFixed(2);
        },

        ///选中
        SelectGoods(item, index) {
            if (item.Select == true) {  ///已经选中了
                delete item.Select;
            }
            else {
                item['Select'] = true;
            }
            this.SelectBean();
        },

        ///分解
        WholeCash() {
            let arr = this.itemLists.filter((item) => {
                return item.Select == true
            })
            if (arr.length == 0) {
                this.$message({
                    message: "未选择饰品，分解失败",
                    type: 'error'
                })
            }

            let data = []
            for (let i = 0; i < arr.length; i++) {
                data.push({
                    "id": arr[i].id
                })
            }
            Cash(JSON.stringify(data)).then((res) => {
                if (res.data.code == 200) {
                    this.$message({
                        message: res.data.message,
                        type: 'success'
                    })
                    this.GetPersonalInfo();
                    this.GetStorage(this.cur_page);
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    })
                }
            })

        },

        ///提货
        WholeExtract(){
			let arr = this.itemLists.filter((item) => {
				return item.Select == true
			})
            if (arr.length == 0) {
                this.$message({
                    message: "未选择饰品，提货失败",
                    type: 'error'
                })
            }

			let data = []
			for (let i = 0; i < arr.length; i++) {
				data.push({
					"id": arr[i].id
				})
			}
            Extract(JSON.stringify(data)).then((res) => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success'
					})
					this.GetStorage(this.cur_page)
					this.GetPersonalInfo()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
			})
        },

		HandleCurrentChange(val) {
			this.GetStorage(val)
			this.cur_page = val;
		},


        GetPersonalInfo() {
            PersonalInfo().then((res) => {
                this.User(res.data.message)
            })
        },

        GetStorage(page) {
            this.loadingShow = true;
            Storage(page).then((res) => {
                if (res.data.data.data.length > 0) {
                    this.itemLists = res.data.data.data;
                    this.item_total_num = Number(res.data.data.total);
                    this.per_page = Number(res.data.data.per_page);
                    this.loadingShow = false;
                }
                else {
                    if (page == '1') {
                        this.itemLists = res.data.data.data;
                        this.item_total_num = Number(res.data.data.total);
                        this.per_page = Number(res.data.data.per_page);
                        this.loadingShow = false;
                    }
                    else {
                        this.GetStorage('1');
                    }
                }
                ///设置没选中
                this.OnSelectAll(this.select_All);
            })


        }
    }
}
</script>

<style lang="scss">
#MyBag {
    box-sizing: border-box;
    padding-top: 3px;
    width: 100%;
    min-height: 500px;
    padding-bottom: 50px;

    .empty_data {
        user-select: none;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;

        p {
            font-size: 16px;
            color: #4c4f53;
            text-align: center;
            white-space: nowrap;
        }
    }
	.PageNum {
		width: 100%;
		text-align: center;
		li {
			background: #111111 !important;

			&.active {
				background: #4854c9 !important;
			}

			&:hover {
				color: #fff !important;
			}
		}

		.btn-prev,
		.btn-next {
			background: #111111;
		}
	}

    .loading {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .bag_header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
        color: #8488a6;
        font-size: 16px;

        .bag_header_l {
            display: flex;
            align-items: center;
            flex: 1;

            p {
                color: #2ae1bc;
                font-size: 15px;
                margin-right: 15px
            }

            .all_price {
                display: flex;
                align-items: center;
                margin-left: 90px;

                img {
                    width: 20px;
                    height: 20px;
                }

                span {
                    color: #FFD077;
                    font-family: "Oxanium";
                    font-size: 16px;
                    margin-bottom: -2px;
                    margin-left: 5px
                }
            }
        }

        .bag_header_c {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 197px;
            height: 105px;
            background: url(../../../assets/images/setting/header_bg.png) center no-repeat;
            background-size: 100% 100%;
            color: #fff;
            font-size: 24px
        }

        .bag_header_r {
            display: flex;
            justify-content: flex-end;
            flex: 1;

            .btn_wrap {
                display: inline-flex;
                width: 146px;
                height: 48px;
                justify-content: center;
                align-items: center;
                background: #181A31;
                margin-left: 10px;
                cursor: pointer;

                &:hover {
                    background: #4854C9;
                    color: #fff
                }

                img {
                    width: 16px;
                    height: auto;
                    margin-left: 12px
                }
            }
        }
    }

    .goods_list_wrap {
        display: flex;
        width: 100%;

        .goods_list {
            display: grid;
            grid-template-columns: repeat(auto-fill, 230px);
            column-gap: 4px;
            row-gap: 4px;
            width: 100%;

            .goods_item {
                width: 230px;
                height: 233px;
                position: relative;
                .goods_item_background{
                    width: 230px;
                    height: 233px;
                    background-size: 100% 100%;
                    background: #15172C;
                    background: url(../../../assets/images/Roll/LV1.png) no-repeat center;
                    background-size: 100% 100%;
                    &.lv1 {
                        background: url(../../../assets/images/Roll/LV1.png) no-repeat center;
                        background-size: 100% 100%;
                    }

                    &.lv2 {
                        background: url(../../../assets/images/Roll/LV2.png) no-repeat center;
                        background-size: 100% 100%;
                    }

                    &.lv3 {
                        background: url(../../../assets/images/Roll/LV2.png) no-repeat center;
                        background-size: 100% 100%;
                    }

                    &.lv4 {
                        background: url(../../../assets/images/Roll/LV3.png) no-repeat center;
                        background-size: 100% 100%;
                    }

                    &.lv5 {
                        background: url(../../../assets/images/Roll/LV3.png) no-repeat center;
                        background-size: 100% 100%;
                    }
                }
                .goods_img {
                    position: absolute;
                    top: 0px;
                    left: 30px;
                    width: 160px;
                    height: 140px;
                    margin: 40px auto 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

                .choose {
                    width: 100%;
                    height: 100%;
                    background: url(../../../assets/images/bag/sel.png) center no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    right: 0;
                    top: 0;
                    opacity: 0;
                    transition: .3;
                }

                .item_info {
                    position: absolute;
                    display: flex;
                    flex-direction: column;
                    margin-left: 10px;
                    font-size: 14px;
                    top: 185px;
                    .price {
                        color: #FFD077;
                        font-family: 'Oxanium';
                        font-size: 13px;
                        display: flex;
                        align-items: center;

                        .price_coin {
                            width: 20px;
                            height: 20px;
                            margin-right: 1px;
                            margin-bottom: 4px;
                        }
                    }

                }

                &.active {
                    .choose {
                        opacity: 1;
                    }
                }
            }



        }
    }
}
</style>
